import debounce from "lodash/debounce";
import { toggleFavouritesSignal } from "@/Groups/Signals/private/api/toggleFavouritesSignal";

export const toggleFavouriteOptimistic = ({ state, commit }, id) => {
  const signal = state.data[id];
  if (!signal) return;

  const currentValue = signal.reactions?.bookmarked?.is_mine ?? false;

  // Сохраняем оригинальное значение только один раз
  if (!(id in state.optimisticOriginal)) {
    state.optimisticOriginal[id] = currentValue;
  }

  const newValue = !currentValue;
  commit("SET_BOOKMARK_STATE", { id, value: newValue });

  if (!state.debounceTimers[id]) {
    state.debounceTimers[id] = debounce(async () => {
      try {
        await toggleFavouritesSignal({
          object_id: id,
          content_type: signal.content_type,
        });

        delete state.optimisticOriginal[id];
        commit("SAVE_FAVORITES_COUNT_TO_STORAGE");
      } catch (err) {
        console.error("Ошибка сервера, откат:", err);
        commit("SET_BOOKMARK_STATE", {
          id,
          value: state.optimisticOriginal[id],
        });
        delete state.optimisticOriginal[id];
        commit("SAVE_FAVORITES_COUNT_TO_STORAGE");
      } finally {
        delete state.debounceTimers[id];
      }
    }, 800);
  }

  state.debounceTimers[id]();
};